import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeaderDivider, LabelValue } from "components";
import { RegistrationJourneyState } from "journey";

export const ContactDetails = ({
  candidateDetails,
}: {
  candidateDetails: NonNullable<RegistrationJourneyState["candidateDetails"]>;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderDivider text={t("details.contactInfoTitle")} sx={{ mb: 3 }} />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.email.label")}
            value={candidateDetails.emailAddress}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.phone.label")}
            value={candidateDetails.phoneNumber}
          />
        </Grid>
        {candidateDetails.guardian && (
          <Grid size={{ xs: 12, md: 6 }}>
            <LabelValue
              label={t("details.guardian.label")}
              value={candidateDetails.guardian}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};
